// Module
var code = "<div aria-label=\"placeholder\" context=\"modal\" ng-if=\"false\"> </div>";
// Exports
export default code;